module.exports = __webpack_public_path__ + "static/media/Habilitacion.48328b8f.jpg";